module.exports = __webpack_public_path__ + "img/stop.7ebde482.svg";